var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"movie poster-all-container"},[_vm._l((_vm.movieList),function(data,i){return _c('starposter',{key:i,attrs:{"mediaitem":data,"isTV":true}})}),_vm._v(" "),_c('div',{staticClass:"load-more-btn",on:{"click":function($event){return _vm.loadmore()}}},[_vm._v("LOAD MORE")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }